let inject = ['$scope', '$uibModalInstance','product', 'ngAuthSettings', 'SharedService', '$timeout'];

class ModalRecommendProductController {
  constructor ($scope,$uibModalInstance,product, ngAuthSettings, SharedService, $timeout) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.SharedService = SharedService;
    this.$uibModalInstance = $uibModalInstance;
    this.ngAuthSettings = ngAuthSettings;
    this.product = Object.assign({}, product);
    this.mailSent = false;
    this.contactDataForm = {};
  }

  sendMailContact(){
    if (this.contactForm.$valid) {
      this.contactDataForm.productName = this.product.name;
      this.contactDataForm.productUrl = this.ngAuthSettings.config.env.basePath + '/#!/app/product-detail-id/' + this.product.id;
      this.SharedService.sendMailContact(this.contactDataForm).then(response => {
        if (!response.error) {
          this.mailSent = true;
          this.$timeout(() => {
            this.ok();
          }, 3000);
        }
      }).catch(reason => {

      });
    }
    else {
      this.contactForm.$error.required.forEach(field =>  {
        field.$setDirty();
      });
    }
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

ModalRecommendProductController.$inject = inject;

export default ModalRecommendProductController;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/modal-recommend-product/modal-recommend-product.controller.js
 **/